import { DefaultParticipantViewUIProps, DefaultScreenShareOverlay, hasScreenShare, MenuToggle, ParticipantDetails, useParticipantViewContext, useStreamVideoClient, StreamVideoEvent, useCall } from "@stream-io/video-react-sdk";
import React, { useEffect, useState } from "react";
import { walletRepository } from "../../../repositories/WalletRepository";
import { useWalletTransactions } from "../../../hooks/useWalletTransactions";
import { useSpecialTransaction } from "../../../hooks/useSpecialTransaction";

interface ActiveReaction {
  id: string;
  x: number;
  y: number;
  type: string;
}

const ParticipantViewUI = ({
    indicatorsVisible = true,
    menuPlacement = 'bottom-start',
    showMenuButton = true,
    ParticipantActionsContextMenu = null as any,
  }: DefaultParticipantViewUIProps) => {
    const { participant, trackType } = useParticipantViewContext();
    const isScreenSharing = hasScreenShare(participant);
    const client = useStreamVideoClient();
    const call = useCall();
    const [activeReactions, setActiveReactions] = useState<ActiveReaction[]>([]);
    const { zapCall } = useSpecialTransaction();

    useEffect(() => {
      if (!client) return;

      const unsubscribe = client.on("call.reaction_new", (event: StreamVideoEvent) => {
        if (event.type === "call.reaction_new" && event.reaction) {          
          const reactionData: ActiveReaction = {
            id: event.reaction.custom?.id || Date.now().toString(),
            x: event.reaction.custom?.x || 0.5,
            y: event.reaction.custom?.y || 0.5,
            type: event.reaction.type || 'zap',
          };

          setActiveReactions(prev => [...prev, reactionData]);

          // Remove reaction after 2 seconds
          setTimeout(() => {
            setActiveReactions(prev => prev.filter(r => r.id !== reactionData.id));
          }, 2000);
        }
      });

      return () => unsubscribe();
    }, [client]);

    const handleClick = async (e: React.MouseEvent<HTMLDivElement>) => {
      if (!call) return;

      const rect = e.currentTarget.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      
      const reactionId = `${Date.now()}-${Math.random()}`;

      await zapCall(call.id, participant.userId);

      await call.sendReaction({
        type: "zap",
        emoji_code: ":zap:",
        custom: { 
          id: reactionId,
          x, 
          y 
        },
      });
    };
  
    if (
      participant.isLocalParticipant &&
      isScreenSharing &&
      trackType === 'screenShareTrack'
    ) {
      return (
        <div onClick={handleClick} className="absolute inset-0">
          <DefaultScreenShareOverlay />
          <ParticipantDetails indicatorsVisible={indicatorsVisible} />
          {activeReactions.map(reaction => (
            <div
              key={reaction.id}
              className="absolute pointer-events-none animate-zap-float"
              style={{
                left: `${reaction.x * 100}%`,
                top: `${reaction.y * 100}%`,
                transform: 'translate(-50%, -50%)',
              }}
            >
              <span className="text-4xl">⚡</span>
            </div>
          ))}
        </div>
      );
    }
  
    return (
      <div onClick={handleClick} className="absolute inset-0">
        <ParticipantDetails indicatorsVisible={indicatorsVisible} />
        {activeReactions.map(reaction => (
          <div
            key={reaction.id}
            className="absolute pointer-events-none animate-zap-float"
            style={{
              left: `${reaction.x * 100}%`,
              top: `${reaction.y * 100}%`,
              transform: 'translate(-50%, -50%)',
            }}
          >
            <span className="text-4xl">⚡</span>
          </div>
        ))}
      </div>
    );
  };

  export default ParticipantViewUI;